// import React from 'react'
// import Navbar from '../Navbar/Navbar'
// import HomeOne from './HomeOne'
// import HomeTwo from './HomeTwo'
// import HomeThree from './HomeThree'
// import HomeFour from './HomeFour'
// import HomeFive from './HomeFive'
// import HomeSix from './HomeSix'
// import HomeSeven from './HomeSeven'
// import Footer from '../Footer/Footer'

// const HomeMain = () => {
//   return (
//     <div>
//         <Navbar/>
//          <HomeOne/>
//          <HomeTwo/>
//          <HomeThree/>
//          <HomeFour/>
//          <HomeFive/>
//          <HomeSix/>
//          <HomeSeven/>
//          <Footer/>

//     </div>
//   )
// }

// export default HomeMain

import React from 'react'
import img from "../../assets/coming_soon.jpg"
const HomeMain = () => {
  return (
    <div>
      <img src={img} alt="Coming Soon Img" />
    </div>
  )
}

export default HomeMain